import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import {
  ReceiptAgent,
  ReceiptAgentRun,
} from 'src/queries/organizations/receiptAgent/receiptAgent.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getReceiptAgent = async (
  organizationId: string,
): Promise<ReceiptAgent> =>
  getResponseData(
    axios.get<ReceiptAgent>(
      `/organizations/${organizationId}/receipt-agent`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const startReceiptAgentRun = async (
  organizationId: string,
  accountingPeriodId: string,
): Promise<ReceiptAgentRun> =>
  getResponseData(
    axios.post<ReceiptAgentRun>(
      `/organizations/${organizationId}/receipt-agent/runs`,
      undefined,
      {
        ...getRequestConfig(RequestConfig.Default),
        params: { accountingPeriodId },
      },
    ),
  )
